export const DEFAULT_CONFIG = {
  academicSession: "2026/2027",
  admissionStatus: "OPEN",
  deadline: "",
  bannerText: "Admissions are now open for eligible candidates. Secure your place for the coming session.",
  bannerCtaLabel: "Apply Now",
  applicationUrl: "https://wa.me/2348072798804?text=Hello%2C%20I%20am%20ready%20to%20begin%20my%20JUPEB%2FIJMB%20registration.%20Please%20send%20me%20the%20official%20registration%20portal%20link",
  phonePrimary: "0807 279 8804",
  phones: ["0816 796 4027", "0802 415 4032", "0807 269 8373"],
  whatsapp: "2348032965859",
  email: "info@iaue.edu.ng",
  website: "www.iaue.edu.ng",
  address: "School of Basic Studies, St. John's Campus, Aba Road, Port Harcourt, Rivers State, Nigeria",
  feesJupeb: "Contact the admissions office for the current JUPEB fee schedule.",
  feesIjmb: "Contact the admissions office for the current IJMB fee schedule.",
  mission: "To provide structured, high-quality academic preparation that equips candidates with the discipline, knowledge and confidence required for the next stage of their education.",
  vision: "To be a trusted foundation programme recognised for academic integrity, quality teaching and preparing students for eligible Direct Entry opportunities.",
  socials: { facebook: "", instagram: "", twitter: "" },
};
